module.exports = __webpack_public_path__ + "static/media/es-welcome.8eb42ee4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/img/es-welcome.svg
// module id = 622
// module chunks = 0 1